// Feature flags — toggle to enable/disable parts of the site.
// Set to true when the digital products are ready (Payhip integration).
export const BOUTIQUE_ENABLED = false;
